"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HideFilterIcon = void 0;
var _react = _interopRequireDefault(require("react"));
const HideFilterIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "17",
  viewBox: "0 0 23 17",
  fill: "#6c757d"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 3.21615H23V0H0V3.21615ZM4.50981 10.1081H18.4902V6.89192H4.50981V10.1081ZM9.01961 17H13.9806V13.7838H9.01961V17Z",
  fill: "#666D74"
}));
exports.HideFilterIcon = HideFilterIcon;